import { useState, useEffect } from "react";
import axios from "axios";
import { GET_USER_ACC_USAGE } from "../services/constants";

const useUserAccountUsage = () => {
  const [accUsage, setAccUsage] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const admin_mail = localStorage.getItem("admin_mail");

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setAccUsage([]); // Reset accUsage when a new request is made
      setError(null);
      try {
        const response = await axios.get(GET_USER_ACC_USAGE(admin_mail));
        setAccUsage(response.data);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    if (admin_mail) {
      fetchData();
    }
  }, [admin_mail]);

  return { accUsage, loading, error };
};

export default useUserAccountUsage;
